import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = "/participant";

export const fetchParticipants = async ({ page, limit } = {}) => {
  let url = BASE_URL;

  if (page && limit) {
    url += `?page=${page}&limit=${limit}`;
  }

  const res = await axiosInstance.get(url, getAuthHeaders());
  return res.data;
};

export const fetchParticipantById = async (uuid) => {
  const res = await axiosInstance.get(`${BASE_URL}/${uuid}`, getAuthHeaders());
  return res.data;
};

export const createOrUpdateParticipant = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/upsert`,
    data,
    getAuthHeaders()
  );

  return res.data;
};

export const deleteParticipant = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/${uuid}`,
    getAuthHeaders()
  );
  return res.data;
};